import React from 'react'
// libs
import styled from 'styled-components'
// constants
import { Modals } from 'constants/modals'
// components
import { IconButton } from 'components/UI'
// hooks
import { useShowModal } from 'hooks'
// icons
import ActivityIconOrigin from 'src/icons/activity-white.svg'
// utils
import { size } from 'polished'

// styled
const ActivityIcon = styled(ActivityIconOrigin)<any>`
  && {
    cursor: pointer;
    ${size('32px')};
  }
`

const ShowPlanActivitiesButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.PLAN_ACTIVITIES_MODAL })

  const showPlanActivities = () => showModal()

  return (
    <IconButton onClick={showPlanActivities} description='Show Plan Activities'>
      <ActivityIcon />
    </IconButton>
  )
}

export default ShowPlanActivitiesButton
